import { render, staticRenderFns } from "./TheProductDetailsAdditionalInfo.vue?vue&type=template&id=58dd1dec&"
import script from "./TheProductDetailsAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./TheProductDetailsAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58dd1dec')) {
      api.createRecord('58dd1dec', component.options)
    } else {
      api.reload('58dd1dec', component.options)
    }
    module.hot.accept("./TheProductDetailsAdditionalInfo.vue?vue&type=template&id=58dd1dec&", function () {
      api.rerender('58dd1dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductDetailsAdditionalInfo.vue"
export default component.exports